import SelfRegistrationPage from './SelfRegistrationPage';

export default SelfRegistrationPage;
